import React from "react";
// SCSS
import "./teamInfo.scss";

const teamInfo = () => (
<div className="team__info flex-center" style={{ width: '700px' }}>
<div>
      <h4 className="font20 weight800">We Are Mediatrix
      </h4>
      <p className="font12 weight500">
      Mediatrix is a creative and production agency that builds the bridge between brands and rights holders — turning strategy into storytelling, and storytelling into impact.
      <br />Based in Morocco and the UAE, we work across industries to design powerful campaigns, content, and partnerships that resonate. From sponsorship and branded content to full-scale production and rights activation, we connect brands with the platforms, audiences, and moments that matter.

Whether you're a global brand seeking deeper engagement or a rights holder ready to scale your value — Mediatrix helps you make the right connection.
      </p>
      <p className="font12 weight500"></p>
    </div>
  </div>
);

export default teamInfo;
